const messages = {
  mn: {
    menu: {
      home: "Нүүр",
      about: "Тухай",
      projects: "Төслүүд",
      contact: "Холбоо барих",
    },
    home: {
      p1:"< /О.Алтангадас >",
      p2:"",
    },
    about: {
      button:"Миний тухай",
      who:"Би хэн бэ",
      pa:"Би 16 настай Олонлог эгзэ ЕБС - ийн сурагч. Мөн би вэб сайт, гар утасны аппликейшн хийх дуртай. Би чөлөөт цагаараа HTML, CSS болон JS - ийг сонирхдог.",
    },
    footer:{
      res:"Бүх эрх хуулиар хамгаалагдсан.",
    },
    contact:{
      p:"Утас",
      i:"Инстаграм",
      f:"Фэйсбүүк",
      e:"И-мэйл",
      se:"Илгээх",
      ss:"Энэ мессежийн хуулбарыг надруу илгээнэ үү",
      na:"Нэр",
      ema:"И-мэйл хаяг",
      mes:"Мэссэж",
    },
  },
  en: {
    menu: {
      home: "Home",
      about: "About",
      projects: "Projects",
      contact: "Contact",
    },
    home:{
      p1:"< /Altangadas.O >",
      p2:"",
    },
    about: {
      button:"About me",
      who:"Who am I",
      pa:"I am 16 Years Old student from Olonlog exe. Also I like do Websites and mobile applications. Therefore, I code HTML, CSS and JS in my freetime.",
    },
    footer:{
      res:" All Rights Reserved.",
    },
    contact:{
      p:"Phone",
      i:"Instagram",
      f:"Facebook",
      e:"Email",
      se:"Send",
      ss:"Send me a copy of this message",
      na:"Name",
      ema:"Email address",
      mes:"Message",
    },
  },
};

export default messages;
